import axios from "axios";

// 서버의 기본 URL을 설정합니다. .env 파일 등을 사용하는 것이 좋습니다.
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3000",
});

// 요청 인터셉터를 사용하여 모든 요청에 인증 토큰을 추가합니다.
apiClient.interceptors.request.use(
  (config) => {
    // 로컬 스토리지 등에서 저장된 accessToken을 가져옵니다.
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
